import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { HcSort, HcTableDataSource, PaginationComponent } from "@healthcatalyst/cashmere";
import { Subject, takeUntil } from "rxjs";
import { ChangeElement, ChangeService } from "src/app/shared/services/change.service";
import { ProductLineService } from "src/app/shared/services/product-line.service";
import { SLAService } from "src/app/shared/services/sla.service";
import { StatusService } from "src/app/shared/services/status.service";
import { TypeService } from "src/app/shared/services/type.service";

/** Admin change log */
@Component({
    selector: 'pd-admin-change-log',
    templateUrl: './admin-change-log.component.html',
    styleUrls: ['./admin-change-log.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminChangeLogComponent implements OnInit, AfterViewInit {
    private unsubscribe = new Subject<void>();
    changesLoading = true;
    changeError = false;
    adminProductChangesDataSource: HcTableDataSource<ChangeElement> = new HcTableDataSource();
    changesDisplayedColumns: string[] = ['date', 'user', 'field', 'previous', 'change'];
    changesPageSize: number = 10;
    manyFields = ['Success Stories', 'Images', 'Included Technology', 'Associated Services', 'Previous Names'];
    htmlFields = ['Tagline', 'Problem', 'Approach', 'Benefits and Features', 'Technical Description', 'Case Studies'];
    idFields = ['Type', 'Product Line', 'Status', 'SLA'];
    typeKey: { [key: string]: string } = {};
    productLineKey: { [key: string]: string } = {};
    statusKey: { [key: string]: string } = {};
    slaKey: { [key: string]: string } = {};

    @ViewChild(HcSort)
    sort: HcSort;

    @ViewChild(PaginationComponent)
    paginator: PaginationComponent;


    get loading(): boolean {
        return this.changesLoading;
    }

    get loadError(): boolean {
        return this.changeError;
    }

    get changesListLength(): number {
        return this.adminProductChangesDataSource.filteredData ? this.adminProductChangesDataSource.filteredData.length : 0;
    }

    constructor(
        private changeService: ChangeService,
        private typeService: TypeService,
        private productLineService: ProductLineService,
        private statusService: StatusService,
        private slaService: SLAService
    ) {}

    ngOnInit(): void {
        this.changesLoading = true;
        this.typeService.allTypeKeyUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.typeKey = list;
                if (this.productLineKey && this.statusKey && this.slaKey) {
                    this.changesLoading = false;
                }
            } else {
                this.typeService.loadAllTypes();
            }
        });

        this.productLineService.productLineKeyUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.productLineKey = list;
                this.changesLoading = false;
                if (this.typeKey && this.statusKey && this.slaKey) {
                    this.changesLoading = false;
                }
            } else {
                this.productLineService.refresh();
            }
        });

        this.statusService.statusKeyUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.statusKey = list;
                if (this.typeKey && this.productLineKey && this.slaKey) {
                    this.changesLoading = false;
                }
            } else {
                this.statusService.refresh();
            }
        });

        this.slaService.slaKeyUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.slaKey = list;
                if (this.typeKey&& this.productLineKey && this.statusKey) {
                    this.changesLoading = false;
                }
            } else {
                this.slaService.refresh();
            }
        });
    }

    ngAfterViewInit(): void {
        this.adminProductChangesDataSource.sort = this.sort;
        this.adminProductChangesDataSource.paginator = this.paginator;
    }

    loadChanges(itemID: number, category: string): void {
        this.changeService
            .load({
                "item": itemID,
                "categories": category
            })
            .pipe(takeUntil(this.unsubscribe))
            .subscribe({
                next: data => {
                    let loadedChanges: ChangeElement[] = [];
                    //display changes with most recent change first
                    data.reverse().forEach((change: any) => {
                        if ( change.update === null ) {
                            change.update = "";
                        }
                        if ( change.previous === null ) {
                            change.previous = "";
                        }
                        loadedChanges.push(change);
                    });
                    this.adminProductChangesDataSource = new HcTableDataSource(loadedChanges);
                    this.adminProductChangesDataSource.sort = this.sort;
                    this.adminProductChangesDataSource.paginator = this.paginator;

                    this.changeError = false;
                    this.changesLoading = false;
                },
                error: msg => {
                    this.changeError = true;
                    this.changesLoading = false;
                    console.log(msg);
                }
            });
    }

    formatID(id: number, type: string) {
        let reformattedID: string = '';

        if (type === "Type") {
            reformattedID = this.typeKey[id.toString()];
        } else if (type === "Product Line") {
            reformattedID = this.productLineKey[id.toString()];
        } else if (type === 'Status') {
            reformattedID = this.statusKey[id.toString()];
        } else if (type === 'SLA') {
            reformattedID = this.slaKey[id.toString()];
        }

        return reformattedID
    }

    //create and object from a string
    createObj(obj: any) {
        return JSON.parse(obj);
    }

}